module.exports = __webpack_public_path__ + "img/avatar.e67a4eb6.svg";